export default "__VITE_ASSET__iUl2BX71__"